import React from "react";
import SideBar from "../../../common/SideBar";
import HeaderBar from "../../../common/HeaderBar";
import NoticeBoardPage1  from "./NoticeBoardPage1";

const NoticeBoardMainPage1 = () => {
  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content inner-page-content--aira-chat">
        <SideBar />
        <NoticeBoardPage1 />
      </div>
    </main>
  );
};

export default NoticeBoardMainPage1;

